import { CasCRUDTable, CasRenderBoolTrue } from 'src/compass/shared/components';
import RequestTypeForm from './RequestTypeForm';

export default function RequestTypesTab() {
  return (
    <CasCRUDTable
      entity="Uploads/RequestType"
      entityTitle="Request Type"
      columns={[
        { field: 'name', showEditOnclick: true },
        { field: 'area' },
        { field: 'emailSubjectTemplate', label: 'Subject' },
        { field: 'fromAgent', label: 'From Agent?', render: CasRenderBoolTrue },
        { field: 'cc', label: 'CC' },
      ]}
      editForm={RequestTypeForm}
    />
  );
}
